// extracted by mini-css-extract-plugin
export default {"spinner":"ProfileInfoForm_spinner__nJ4Eq"};